import React from "react";
import {
  alpha,
  Card,
  CardActionArea,
  Typography,
  useTheme,
  Box,
  CircularProgress,
  Fade
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const AddTaxComputationCard = ({ onClick, loading = false }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        width: "100%",
        height: 260,
        display: "flex",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        borderRadius: 3,
        border: "2px dashed",
        borderColor: alpha(theme.palette.primary.main, 0.2),
        bgcolor: alpha(theme.palette.primary.main, 0.03),
        backdropFilter: "blur(4px)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

        // 渐变边框效果
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "inherit",
          padding: "2px",
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitMask:
            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
          opacity: 0,
          transition: "opacity 0.3s ease"
        },

        // 悬停效果
        "&:hover": {
          borderColor: alpha(theme.palette.primary.main, 0.5),
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          transform: "translateY(-6px)",
          boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.12)}`,

          "&::before": {
            opacity: 1
          },

          "& .add-icon": {
            color: "primary.main",
            transform: "scale(1.2) rotate(90deg)",
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
          },

          "& .add-text": {
            color: "primary.main",
            transform: "translateY(-2px)"
          },

          "& .add-subtext": {
            opacity: 1,
            transform: "translateY(0)"
          }
        },

        // 点击效果
        "&:active": {
          transform: "translateY(-2px)",
          boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.15)}`
        },
        ...(loading && { pointerEvents: "none", cursor: "default" })
      }}
      onClick={loading ? undefined : onClick}
    >
      <CardActionArea
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
          height: "100%",
          position: "relative",
          zIndex: 1
        }}
      >
        {loading ? (
          <Fade in>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: alpha(theme.palette.primary.main, 0.06),
                backdropFilter: "blur(4px)",
                zIndex: 2,
                borderRadius: "inherit"
              }}
            >
              <CircularProgress
                size={44}
                thickness={3.2}
                sx={{
                  color: "primary.main",
                  mb: 1.5,
                  "& .MuiCircularProgress-circle": {
                    strokeLinecap: "round"
                  }
                }}
              />
              <Typography
                variant='body2'
                sx={{
                  color: "text.secondary",
                  fontWeight: 500,
                  fontSize: "0.8125rem"
                }}
              >
                Working on it...
              </Typography>
            </Box>
          </Fade>
        ) : (
          <>
            {" "}
            <Box
              sx={{
                position: "relative",
                mb: 2,
                zIndex: 1
              }}
            >
              <AddIcon
                className='add-icon'
                sx={{
                  color: "text.secondary",
                  fontSize: 48,
                  position: "relative",
                  zIndex: 1,
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                }}
              />
            </Box>
            <Box sx={{ textAlign: "center", zIndex: 1 }}>
              <Typography
                className='add-text'
                variant='h6'
                fontWeight={600}
                sx={{
                  color: "text.secondary",
                  mb: 0.5,
                  fontSize: "1.125rem",
                  transition: "all 0.3s ease"
                }}
              >
                Add Tax Computation
              </Typography>

              <Typography
                className='add-subtext'
                variant='body2'
                sx={{
                  color: "text.secondary",
                  opacity: 0.7,
                  fontSize: "0.8125rem",
                  transition: "all 0.3s ease",
                  opacity: 0,
                  transform: "translateY(4px)"
                }}
              >
                Create new computation
              </Typography>
            </Box>
          </>
        )}
      </CardActionArea>
    </Card>
  );
};

export default AddTaxComputationCard;
